import { useState } from "react";
import useTranslator from "../../hooks/useTranslator";
import FreshFruitRunningTotals from "./components/FreshFruitRunningTotals";
import ColdRoomDataOverview from "./components/ColdRoomDataOverview";
import "./components/dashboard-sections.css";

const Dashboard = () => {
  const { _t } = useTranslator();
  const [period, setPeriod] = useState("daily");

  // Set to true to preview shimmer loading state
  const isLoading = false;

  const periods = [
    { key: "daily",   label: _t("daily",   "Daily")   },
    { key: "weekly",  label: _t("weekly",  "Weekly")  },
    { key: "monthly", label: _t("monthly", "Monthly") },
  ];

  return (
    <div>
      {/* Header */}
      <div className="db-header">
        <div className="db-header-title">
          <h2>{_t("dashboard_title", "Off The Tree Dashboard")}</h2>
          <p>{_t("dashboard_subtitle", "Real-time supply chain and maturity metrics overview")}</p>
        </div>
        <ul className="db-period-toggle">
          {periods.map((p) => (
            <li
              key={p.key}
              className={period === p.key ? "active" : ""}
              onClick={() => setPeriod(p.key)}
            >
              {p.label}
            </li>
          ))}
        </ul>
      </div>

      <FreshFruitRunningTotals isLoading={isLoading} />
      <ColdRoomDataOverview isLoading={isLoading} />
    </div>
  );
};

export default Dashboard;